<form [formGroup]="arrayformGroup">
    <div [formArrayName]="formArrayName" class="gap-3 mt-3" >
        <mat-card>
          <mat-card-header class="api-header mb-4">
            <div class="d-flex align-items-center justify-content-between w-100">
              <mat-card-title class="api-header-title ">
                {{label}}
              </mat-card-title>
              <button mat-mini-fab color="primary" type="button" (click)="addItem()">
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </mat-card-header>

          <mat-card-content>
            <ng-container *ngFor="let item of items?.controls; let index = index">
              <div class="row g-3" [formGroupName]="index">
                <div class="col">
                  <mat-form-field class="w-100 rounded-0" appearance="outline">
                    <mat-label>Key</mat-label>
                    <input matInput formControlName="key" />
                    <mat-error *ngIf="item.get('key')?.hasError('required')">This field is required.</mat-error>
                    <mat-hint *ngIf="isKeyExists">This key already exists.</mat-hint>
                  </mat-form-field>
                </div>
              <ng-container *ngIf="tabType === apiTabTypes.headers">
                <div class="col" >
                  <mat-form-field class="w-100 rounded-0" appearance="outline">
                    <mat-label>Value</mat-label>
                    <input matInput formControlName="value" />
                    <mat-error *ngIf="item.get('value')?.hasError('required')">This field is required.</mat-error>
                  </mat-form-field>
                </div>
              </ng-container>
              <ng-container *ngIf="tabType === apiTabTypes.queryParems">
                <div class="col">
                  <mat-form-field class="w-100 rounded-0" appearance="outline">
                    <mat-label>Type</mat-label>
                    <mat-select formControlName="type">
                      <mat-option *ngFor="let type of ['manual','variable']" [value]="type">
                        {{type}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="item.get('type')?.hasError('required')">This field is required.</mat-error>
                  </mat-form-field>
                </div>
                <div class="col" *ngIf="item.get('type')?.value === 'manual'">
                  <mat-form-field class="w-100 rounded-0" appearance="outline">
                    <mat-label>Value</mat-label>
                    <input matInput formControlName="value" />
                    <mat-error *ngIf="item.get('value')?.hasError('required')">This field is required.</mat-error>
                  </mat-form-field>
                </div>
                <div class="col" *ngIf="item.get('type')?.value === 'variable'">
                  <mat-form-field class="w-100 rounded-0" appearance="outline">
                    <mat-label>Value</mat-label>
                    <mat-select formControlName="value">
                      <mat-option *ngFor="let variable of currentFormValue.variables" [value]="variable.key">
                        {{variable.key}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="item.get('value')?.hasError('required')">This field is required.</mat-error>
                  </mat-form-field>
                </div>
              </ng-container>
              <ng-container *ngIf="tabType === apiTabTypes.variables">
                <div class="col" >
                    <mat-form-field class="w-100 rounded-0" appearance="outline">
                      <mat-label>Type</mat-label>
                      <mat-select formControlName="type" >
                        <mat-option *ngFor="let type of dataTypes" [value]="type">{{type | titlecase}}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="item.get('type')?.hasError('required')">This field is required.</mat-error>
                    </mat-form-field>
                </div>
                <div class="col">
                    <mat-form-field class="w-100 rounded-0" appearance="outline">
                      <mat-label>Default Value</mat-label>
                      <input matInput formControlName="defaultValue" />
                      <mat-error *ngIf="item.get('defaultValue')?.hasError('required')">This field is required.</mat-error>
                    </mat-form-field>
                </div>
              </ng-container>
                <div class="col-auto">
                  <button mat-mini-fab color="warn" class="mt-2" type="button" (click)="removeItem(index)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>

            </ng-container>
          </mat-card-content>
        </mat-card>
      </div>
</form>